export default __webpack_public_path__ + "static/media/light.ae9081c9.png";